export default __webpack_public_path__ + "static/media/nodejs.fb1a26c2.png";